import { FmaSliceSettingsSchema, fmaSliceParameters } from './shared.js';

export default {
  label: 'RMS wavefront versus field', group: 'performance',
  description: 'RMS wavefront error along a field slice.',
  settingsSchema: FmaSliceSettingsSchema,
  parameters: fmaSliceParameters,
  coverage: 'For focal (non-afocal) systems, along the X or Y axis of the field. Values are in waves at the wavelength CODE V reports, with the minimum, maximum, average and standard deviation. Not supported: oblique slices and two-dimensional maps.',
} as const;
